import { action } from 'typesafe-actions'
import { FiltersTypes, FiltersI } from './types'

export const filtersSet = (data: FiltersI[]) =>
  action(FiltersTypes.FILTERS_SET_SUCCESS, data)

export const filtersFailed = () => action(FiltersTypes.FILTERS_SET_FAILED)

export const filtersClean = () => action(FiltersTypes.FILTER_SET_CLEAN)
